
ADILF.define('streamhub-sdk/view',['view'], function(View) {
    'use strict';
    return View;
});
